import { render, staticRenderFns } from "./FieldDateAndLabel.vue?vue&type=template&id=792be3b1&scoped=true"
import script from "./FieldDateAndLabel.vue?vue&type=script&lang=js"
export * from "./FieldDateAndLabel.vue?vue&type=script&lang=js"
import style0 from "./FieldDateAndLabel.vue?vue&type=style&index=0&id=792be3b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792be3b1",
  null
  
)

export default component.exports